<template>
  <div class="charecteristc main-block">
    <div class="main-block__head">
      <h1 class="main-block__title">Расходы автомобиля  </h1>
    </div>
    <div class="charecteristc__block row">
      <div class="col">
        <div class="stats">
          <span class="dot orange"></span> <span class="count">{{ thousandsWithSpaces(this.parts) }} ₸</span> <br> <br>
          <div class="flex">
            <span class="title">Закуп запчастей</span> <span class="percent">{{ this.total ? Number((this.parts/this.total*100).toFixed(this.toFixed)) : 0 }} %</span>
          </div>
        </div>
        <div class="stats">
          <span class="dot green"></span> <span class="count">{{ thousandsWithSpaces(this.repair) }} ₸</span> <br> <br>
          <div class="flex">
            <span class="title">Услуги ремонта</span> <span class="percent">{{ this.total ? Number((this.repair/this.total*100).toFixed(this.toFixed)) : 0 }} %</span>
          </div>
        </div>
        <div class="stats">
          <span class="dot blue"></span> <span class="count">{{ thousandsWithSpaces(this.insurance) }} ₸</span> <br> <br>
          <div class="flex">
            <span class="title">Страховка</span> <span class="percent">{{ this.total ? Number((this.insurance/this.total*100).toFixed(this.toFixed)) : 0 }} %</span>
          </div>
        </div>
      </div>
      <div class="col">
        <apexchart type="donut" :options="options" :series="series" />
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  name: "Cost",
  title: "Transport costs",
  props: {
    allCarsData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toFixed: 0,
      parts: 0,
      repair: 0,
      insurance: 0,
    };
  },
  computed: {
    series() {
      return [
      this.insurance, this.repair, this.parts, 
      ];
    },
    options() {
      return {
        labels: ['Страховка', 'Услуги ремонта', 'Закуп запчастей',],
        chart: {
          type: 'donut'
        },
        dataLabels: {
          enabled: false,
          formatter: function (val) {
            return Number((val).toFixed(0)) + "%"
          },
          style: {}
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            customScale: 0.8,
            donut: {
              size: '90%',
              labels: {
                show: true,
                name: {
                  
                },
                value: {

                },
                total: {
                  show: true,
                  label: "За последний год",
                  color: '#000000',
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ₸'
                  }
                }
              }
            }
          }
        }
      }
    },
    total() {
      return this.parts + this.repair + this.insurance
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    thousandsWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    getData() {
      this.$api
        .get("/web/transport/cost/" + this.allCarsData.id)
        .then((response) => {
          this.parts = response.data.parts
          this.repair = response.data.repair
          this.insurance = response.data.insurance
        })
        .catch(() => {
          this.$toast.error('Что-то пошло не так, попробуйте позднее!');
        });
    },
  }
};
</script>

<style scoped>
.charecteristc__block {
  align-items: flex-start;
}
.dot {
  width: 15px;
  height: 15px;
  border-radius: 1px;
  display: inline-block;
}
.green {
  background: rgb(0, 227, 150);
}
.orange {
  background: rgb(254, 176, 25);
}
.blue {
  background: rgb(0, 143, 251)
}
.title {
  margin-left: 18px;
  font-weight: 400;
}
.count {
  font-size: 20px;
}
.stats {
  margin: 30px 0 0 30px;
  font-size: 14px;
}
.percent {
  color: #ACACAC
}
</style>
